import { Command } from '@/app/common/base/command'
import { MyUploadedDocument } from '@/app/my-uploaded-documents/entities/my-uploaded-document.entity'

export class GetMyUploadedDocumentsCommand extends Command {
    public async run() {
        try {
            const response = await this.client.get('/api/my-uploaded-documents')
            const documents = response.asEntities(MyUploadedDocument)
            await this.store.dispatch('myUploadedDocuments/updateDocuments', documents)
        } catch (err) {
            const message = (err as Error)?.message || 'Failed to load documents'
            await this.store.commit('myUploadedDocuments/setError', message)
            await this.store.commit('myUploadedDocuments/setHasLoaded', true)
        }
    }
}


